export default __webpack_public_path__ + "media/images/filter_none-2bb681ed8381298d1a977bbade95737f.png";